<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-labelledby="Twitter" role="img">
  <path
    d="M13.712 10.622 20.413 3h-1.588l-5.818 6.618L8.36 3H3l7.027 10.007L3 21h1.588l6.144-6.989L15.64 21H21l-7.288-10.378Zm-2.175 2.473-.712-.996-5.665-7.93H7.6l4.571 6.4.712.996 5.943 8.318h-2.439l-4.85-6.787Z"
  />
</svg>
